import React, { useState } from "react";

function CustomDateRange({ onRangeChange }) {
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const handleFromChange = (e) => {
    const from = e.target.value;
    setCustomFrom(from);
    if (from && customTo && onRangeChange) {
      onRangeChange({ type: "custom", from, to: customTo });
    }
  };

  const handleToChange = (e) => {
    const to = e.target.value;
    setCustomTo(to);
    if (customFrom && to && onRangeChange) {
      onRangeChange({ type: "custom", from: customFrom, to });
    }
  };

  return (
    <div className="dr-custom" data-cy="dr-custom-row">
      <input
        type="date"
        value={customFrom}
        onChange={handleFromChange}
        data-cy="dr-from-input"
      />
      <span>to</span>
      <input
        type="date"
        value={customTo}
        onChange={handleToChange}
        data-cy="dr-to-input"
      />
    </div>
  );
}

export default CustomDateRange;
